import React, { useContext, useEffect, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import { AppContext } from '@/AppContext';
import { WSContext } from '../../WSContext';
import { render } from 'react-dom';
import { IconButton, Toolbar } from '@mui/material';
import { Notifications as NsIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import ListItemText from '@mui/material/ListItemText';
import SvgIcon from '@mui/material/SvgIcon';
import Avatar from '@mui/material/Avatar';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Popover from '@mui/material/Popover';
import Badge from '@mui/material/Badge';
import { shortenDate } from '@/views/MeetupList/components/MeetupsTable/MeetupsTable';

const PREFIX = 'Notifications';

const classes = {
  topBarIcon: `${PREFIX}-topBarIcon`,
  popover: `${PREFIX}-popover`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.topBarIcon}`]: {
    marginRight: '8px',
  },

  [`& .${classes.popover}`]: {
    width: 320,
  },
}));

export const Notifications = () => {
  const theme = useTheme();

  const appContext = useContext(AppContext);
  const wsContext = useContext(WSContext);

  const ref = useRef(null);
  const [ns, setNs] = useState([]);
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    wsContext.addListener(wsMessageReceiver);
    wsContext.send({ n11s: {} });
    return () => {
      wsContext.removeListener(wsMessageReceiver);
    };
  }, []);

  // TODO: refactor it. use correct state handling.
  let nsNotInState = ns;
  const wsMessageReceiver = message => {
    if (message.n11s) {
      nsNotInState = nsNotInState.concat(message.n11s).sort(e => -new Date(e.timestamp).getTime());
      setNs(nsNotInState);
    }
    if (message.n11sClear) {
      nsNotInState = [];
      setNs(nsNotInState);
    }
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const clear = () => {
    if (ns.length > 0) {
      appContext.notificationApi.deleteNotifications(ns[0].timestamp);
    }
  };

  return (
    <Root>
      <Tooltip title='Notifications'>
        <IconButton
          style={{ color: theme.palette[theme.appBarColor].contrastText }}
          className={classes.topBarIcon}
          ref={ref}
          onClick={handleOpen}
          data-test-id='top-notifications'
          size='large'
        >
          <Badge badgeContent={ns.length} color='error'>
            <NsIcon />
          </Badge>
        </IconButton>
      </Tooltip>
      <Popover
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        classes={{ paper: classes.popover }}
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        data-test-id='notifications-popover'
      >
        <Box p={2}>
          <Typography variant='h5' color='textPrimary'>
            Уведомления
          </Typography>
        </Box>
        {ns.length === 0 ? (
          <Box p={2}>
            <Typography color='textPrimary'>Новых уведомлений нет</Typography>
          </Box>
        ) : (
          <>
            <List className={classes.list} disablePadding>
              {ns.map(notification => {
                //const Icon = iconsMap[notification.type];

                return (
                  <ListItem className={classes.listItem} divider key={notification.id} to='#'>
                    {/*<ListItemAvatar>*/}
                    {/*  <Avatar*/}
                    {/*    className={classes.icon}*/}
                    {/*  >*/}
                    {/*    <SvgIcon fontSize="small">*/}
                    {/*      <Icon />*/}
                    {/*    </SvgIcon>*/}
                    {/*  </Avatar>*/}
                    {/*</ListItemAvatar>*/}
                    <ListItemText
                      primary={notification.message.text}
                      primaryTypographyProps={{ variant: 'subtitle2', color: 'textPrimary' }}
                      secondary={shortenDate(notification.timestamp)}
                    />
                  </ListItem>
                );
              })}
            </List>
            <Box p={1} display='flex' justifyContent='center'>
              <Button
                size='small'
                onClick={() => {
                  clear();
                  nsNotInState = [];
                }}
              >
                Очистить
              </Button>
            </Box>
          </>
        )}
      </Popover>
    </Root>
  );
};
